import PERM_FORMAT from 'constants/form/permFormat.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const fromEntryToChoice = (dto) => {
  const key = fromAnyToString(dto?.[0]);
  const val = dto?.[1] ?? {};

  return { ...val, key };
};

const fromEntryToEditablePermission = (dto) => {
  const key = fromAnyToString(dto?.[0]);
  const val = dto?.[1] ?? {};

  const { format, enabled, label, choices } = val;

  if (PERM_FORMAT.checkbox === format) return { key, format, enabled, label };
  if (PERM_FORMAT.radio === format) {
    return { key, format, enabled, choices: fromObjectToEntries(choices).map(fromEntryToChoice) };
  }

  return { key, ...val };
};

const fromEntryToCategory = (dto) => {
  const val = dto ?? {};

  const name = val?.category_name;
  const description = val?.category_description;
  const perms = fromObjectToEntries(val?.permissions ?? {});

  return { name, description, permissions: perms.map(fromEntryToEditablePermission) };
};

// SEE: https://github.com/getslick/api.core/blob/staging/docs/CustomPermissions.md
const fromDtoToPermissionCategories = (dto) => (isPositiveInteger(dto._v) ? asArray(dto?.results?.permission_details).map(fromEntryToCategory) : dto);

export default fromDtoToPermissionCategories;
